import { render, staticRenderFns } from "./Qr.vue?vue&type=template&id=70e3be1c&scoped=true&"
import script from "./Qr.vue?vue&type=script&lang=js&"
export * from "./Qr.vue?vue&type=script&lang=js&"
import style0 from "./Qr.vue?vue&type=style&index=0&id=70e3be1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e3be1c",
  null
  
)

export default component.exports